import { cardsData } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20composition%20with%20golden%20geometric%20shapes%20on%20cream%20background%2C%20soft%20elegant%20lighting%2C%20modern%20lifestyle%20aesthetic%2C%20clean%20simple%20design%2C%20premium%20textured%20finish&width=800&height=600&seq=card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20layered%20waves%20in%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20modern%20art%2C%20soft%20diffused%20light%2C%20elegant%20composition%2C%20clean%20premium%20aesthetic&width=800&height=600&seq=card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20abstract%20circles%20in%20terracotta%20and%20warm%20beige%20hues%2C%20minimalist%20gallery%20style%2C%20soft%20atmospheric%20lighting%2C%20elegant%20refined%20composition%2C%20smooth%20textures&width=800&height=600&seq=card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20abstract%20fluid%20flowing%20shapes%20in%20golden%20honey%20and%20cream%2C%20modern%20luxurious%20design%2C%20soft%20ethereal%20lighting%2C%20elegant%20minimalist%20aesthetic%2C%20premium%20textures&width=800&height=600&seq=card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Contemporary%20abstract%20geometric%20grid%20in%20warm%20amber%20and%20cream%2C%20modern%20clean%20design%2C%20soft%20ambient%20light%2C%20minimalist%20aesthetic%2C%20premium%20elegant%20composition&width=800&height=600&seq=card-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20abstract%20organic%20patterns%20in%20terracotta%20warm%20beige%20and%20cream%2C%20modern%20art%20style%2C%20soft%20diffused%20lighting%2C%20minimalist%20luxurious%20aesthetic%2C%20smooth%20textured%20finish&width=800&height=600&seq=card-06&orientation=landscape',
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {cardsData.title}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsData.items.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={cardImages[i]}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}